module.exports = __webpack_public_path__ + "static/media/kmlHome.16fbdce3.png";